import type { RealestateAsset } from "~/types/assets.types";
import type { Fiat } from "~/types/global.types";
import { calculateRealestateTotalExpenses } from "./totalExpenses";

export const calculateRealestateYearlySum = (
  userProduct: RealestateAsset,
  baseCurrency: Fiat,
  currentCurrency: Fiat
) => {
  return calculateRealestateTotalExpenses(
    userProduct,
    baseCurrency,
    currentCurrency
  );
};
